import { NamedItem, RenewalIchraEmployeeRequest } from 'core'
import {
  EligibleEmployeeInfoDto,
  RenewalClassesDTO,
} from 'core/application/adminDashboard/benefitRenewal/confirmEmployeeClasses/confirmEmployeeClasses'

import { Icon, SimpleSelect, Table } from 'common/components'

type EligibleEmployeesIchraRenewalTableProps = {
  translate: (key: string) => string
  renewalClasses: RenewalClassesDTO[]
  employees: EligibleEmployeeInfoDto[]
  submitList: RenewalIchraEmployeeRequest[]
  renewalYear: number
  onSelectedItemsChanged?: (items: RenewalIchraEmployeeRequest[]) => void
}

const EligibleEmployeesIchraRenewalTable = ({
  renewalClasses,
  employees,
  translate,
  submitList,
  renewalYear,
  onSelectedItemsChanged,
}: EligibleEmployeesIchraRenewalTableProps) => {
  const addToSubmitList = (employeeId: string, renewalClassId: string) => {
    const employee: RenewalIchraEmployeeRequest = { id: employeeId, classId: renewalClassId }
    const temp = submitList.filter((x) => x.id !== employeeId)
    temp.push(employee)
    onSelectedItemsChanged(temp)
  }
  const columns: any[] = [
    {
      title: translate('admin-dashboard.home.confirm-renewal-classes.first-name'),
      dataIndex: 'firstName',
      key: 'firstName',
    },
    {
      title: translate('admin-dashboard.home.confirm-renewal-classes.last-name'),
      dataIndex: 'lastName',
      key: 'lastName',
    },
    {
      title: 'Status',
      dataIndex: 'employmentStatus',
      key: 'employmentStatus',
    },
    {
      title: `${renewalYear - 1} Class`,
      dataIndex: 'employeeClass',
      key: 'employeeClass',
    },
    {
      title: `${renewalYear} Class assignment`,
      key: 'workEmail',

      render: (value: NamedItem, record: any) => {
        const currentValue = submitList.find((x) => x.id === record.employeeId)?.classId
        return (
          <SimpleSelect
            value={currentValue}
            onChange={(value) => addToSubmitList(record.employeeId, value)}
            status={Number(currentValue) === -1 ? 'warning' : null}
            items={[
              {
                name: (
                  <div className="flex flex__align_center">
                    <Icon type="fas fa-exclamation-triangle" className="color-yellow-7 mr-8" />
                    Unassigned
                  </div>
                ),
                id: -1,
              },
              ...renewalClasses,
              { name: 'Ineligible', id: null },
            ]}
          />
        )
      },
    },
  ]

  return <Table dataSource={employees} columns={columns} scroll={{ x: 1000 }} />
}

export default EligibleEmployeesIchraRenewalTable
